export function isEmpty(str: string): boolean {
    const isEmptyOrDefault = (value: string | undefined | null): boolean =>
        !value;

    return isEmptyOrDefault(str);

}